<template>
    <div class="apiconfigure">
        <div class="title">
            <i></i>
            <span>回调记录</span>
        </div>
        <el-form :inline="true" class="search-common-box">
            <el-form-item label="回调类型">
                <el-select v-model="search.type" placeholder="请选择" clearable>
                    <el-option :label="bean.desc" :key="i" :value="bean.type" v-for="(bean,i) in typeList"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="回调结果">
                <el-select v-model="search.sendResult" placeholder="请选择" clearable>
                    <el-option label="成功" value="1"></el-option>
                    <el-option label="失败" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="warning" @click="current=1;getList()">查询</el-button>
            </el-form-item>
        </el-form>
        <div class="table-content" v-if="mainInfo.isOpenApi==1">
            <el-table ref="singleTable" border :stripe='true' :data="tableData" style="width: 100%" v-loading="listLoading">
                <el-table-column type="expand">
                    <template slot-scope="scope">
                        <div class="content-title">回调内容</div>
                        <div class="content-pre">{{JSON.stringify(JSON.parse(scope.row.content),null,2)}}</div>
                        <!-- {{scope.row.content}} -->
                    </template>
                </el-table-column>
                <el-table-column type="index" width="50" align="center"></el-table-column>
                <el-table-column property="typeDesc" label="回调类型" min-width="140"></el-table-column>
                <el-table-column property="createTime" label="创建时间" width="180" align="center"></el-table-column>
                <el-table-column property="sendResult" label="回调结果" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag type="success" effect="dark" v-if="scope.row.sendResult==1">成功</el-tag>
                        <el-tag type="danger" effect="dark" v-else>失败</el-tag>
                    </template>
                </el-table-column>
                <el-table-column property="responseMsg" label="响应结果" min-width="200"></el-table-column>
                <!-- <el-table-column property="content" label="回调内容"></el-table-column> -->
                <el-table-column label="操作" width='100' align="center">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="primary" size='small' @click="supply(scope.row)">补传</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page.sync='current' background layout="total,prev, pager, next" :page-size='10' @current-change="getList" :total="total">
            </el-pagination>
        </div>
        <div class="content" v-if="mainInfo.isOpenApi==0">
            <div class="no">
                <img src="@static/images/no.png" alt="">
                <span>该功能暂未开放，如需了解请联系商务人员</span>
            </div>
        </div>
    </div>
</template>
<script>
//当前实例组件

export default {
    data: () => ({
        listLoading:false,
        tableData:[],
        current:1,
        total:0,
        mainInfo:{},
        search:{},//查询参数
        typeList:[],//回调类型

    }),
    created() {
        this.queryMechanInfo();
        this.getList();
        this.getTypeList();
    },
    methods: {
        // 获取回调类型
        getTypeList(){
            this.$http({
                url: '/master/mechan/queryAllNotifyType',
                type: 'get',
                params:{},
            }).then((res)=> {
                this.typeList = res.data;
            })
        },
        //获取主体信息
        queryMechanInfo:function(){
            this.$http({
                url: '/master/mechan/queryMechanInfo',
                type: 'put',
                params:{},
            }).then((res)=> {
                this.mainInfo = res.data;
                if(this.mainInfo.isOpenApi==1) {
                    this.getList();
                }
            })
        },
        // 获取列表
        getList(){
            this.listLoading = true;
            const params = Object.assign({},this.search);
            params.pageSize = 10;
            params.pageNum = this.current;
            this.$http({
                url: '/master/mechan/queryMechanNotifyRecordList',
                type: 'put',
                params:params,
            }).then((res)=> {
                this.listLoading = false;
                this.tableData = res.data;
                this.total = res.total;
            })
        },
        // 补传
        supply(item) {
            this.$http({
                url: '/master/mechan/pushNotifyAgain/'+item.id,
                type: 'get',
                params:{},
            }).then((res)=> {
                this.$message.success("补传操作成功");
                this.current = 1;
                this.getList();
            })
        }
    }
};
</script>
<style lang="scss">
@import "./apiCommon.scss";
</style>
